import { render, staticRenderFns } from "./PreventProjectDraftModal.vue?vue&type=template&id=2ea18c83&scoped=true&"
import script from "./PreventProjectDraftModal.vue?vue&type=script&lang=js&"
export * from "./PreventProjectDraftModal.vue?vue&type=script&lang=js&"
import style0 from "./PreventProjectDraftModal.vue?vue&type=style&index=0&id=2ea18c83&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ea18c83",
  null
  
)

export default component.exports